import { Button as MuiButton } from '@mui/material';
import { ButtonProps } from './button.types';

const Button: React.FC<ButtonProps> = (props): React.ReactElement => <MuiButton {...props} />;

export default Button;
